import { EEventPartType } from 'data/types/events.types';
import { Flex } from 'antd';
import { TDateTimeProps } from './DateTime.types';
import PartDateInput from './PartDateInput';

const PartsDate = ({ id, parts, eventStatus }: TDateTimeProps) => {
  const getPrevAndNextPartDates = (part: EEventPartType) => {
    const getDateTime = (partType: EEventPartType) => {
      return parts?.find(pt => pt.partType === partType)?.date?.value || '';
    };
    switch (part) {
      case EEventPartType.PART_ONE: {
        const nextPartDateTime = getDateTime(EEventPartType.PART_TWO);
        return { nextPartDateTime };
      }
      case EEventPartType.PART_TWO: {
        const previousPartDateTime = getDateTime(EEventPartType.PART_ONE);
        const nextPartDateTime = getDateTime(EEventPartType.PART_THREE);
        return { previousPartDateTime, nextPartDateTime };
      }
      case EEventPartType.PART_THREE: {
        const previousPartDateTime = getDateTime(EEventPartType.PART_TWO);
        return { previousPartDateTime };
      }
      default: {
        return { previousPartDateTime: '', nextPartDateTime: '' };
      }
    }
  };
  return (
    <Flex vertical gap={16}>
      {parts?.map(part => {
        return (
          <PartDateInput
            part={part}
            eventId={id}
            key={part.eventPartId}
            {...getPrevAndNextPartDates(part.partType)}
            eventStatus={eventStatus}
          />
        );
      })}
    </Flex>
  );
};

export default PartsDate;
